import {InputBaseComponentProps} from '@material-ui/core';
import {EmptyString, NonEmptyString, StringUnion} from 'Core/models/EmptyString';
import React, {useState} from 'react';
import {Errors} from 'Shared/components/ErrorPopover';
import ValidatableTextField from 'Shared/components/ValidatableTextField';
import {ValidationError} from 'Users/ducks/independentAgent';

type RequiredTextInputProps = {
  id?: string;
  value: StringUnion;
  onChange: (value: StringUnion) => void;
  label: string;
  onValidate?: (filedName: string, value: string) => string | undefined;
  changeError?: (errors: ValidationError[]) => void;
  additionalErrors?: ValidationError[];
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  multiline?: boolean;
  inputProps?: InputBaseComponentProps;
};

const RequiredTextInput = (props: RequiredTextInputProps) => {
  const {additionalErrors, label, onValidate, changeError, multiline, placeholder, disabled, className} = props;
  const [hasBeenBlurred, setHasBeenBlurred] = useState(false);

  const validationError = additionalErrors && additionalErrors.find(x => x.fieldName === label);

  const errors = Errors.standardErrors({
    value:
      props.value instanceof EmptyString ? ['Please supply a value.'] : validationError ? [validationError.error] : [],
  });

  return (
    <ValidatableTextField
      multiline={multiline}
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      errors={errors}
      showErrors={errors => hasBeenBlurred && errors.value.length > 0}
      className={className}
      onBlur={() => setHasBeenBlurred(true)}
      onChange={value => {
        if (onValidate && changeError && additionalErrors && value !== new EmptyString().value) {
          const error = onValidate(label, value);
          const errorExist = additionalErrors.filter(x => x.fieldName === label).length > 0;
          if (error && !errorExist) {
            const errorData: ValidationError = {fieldName: label, error};
            changeError([...additionalErrors, errorData]);
          } else if (!error) {
            const remainingErrors = additionalErrors.filter(x => x.fieldName !== label);
            changeError(remainingErrors);
          }
        }
        props.onChange(NonEmptyString.create(value));
      }}
      inputProps={props.inputProps}
      value={props.value.value}
    />
  );
};

export default RequiredTextInput;
